import React from "react";

const Buttons = () => {
    return (
        <div className="footer__wrapper__buttons">
            <button className="btn">Request Invite</button>
        </div>
    );
};

export default Buttons;
